<template>
  <div>
    <LoadingSpinner />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from "vue";
import { logEvent, logException } from "@/common/logger";
import { useRoute, useRouter } from "vue-router";
import { usePayPalStore } from "@/stores/payPal";
import LoadingSpinner from "@/components/shared/LoadingSpinner.vue";
const componentName = "ReturnComponent";

logEvent("created", componentName);
const route = useRoute();
const router = useRouter();
const payPalStore = usePayPalStore();

const token = route.query.token?.toString() || "";
const ba_token = route.query.ba_token?.toString() || "";

onMounted(async () => {
  try {
    logEvent("mounted", componentName);
    //check Billing Agreement token exist
    if (token != "" && ba_token != "") {
      //set the Billing Agreement Response in store
      await payPalStore.setPayPalBillingAgreementResponse(ba_token);
      //redirect to reviewOrderPage
      router.push(payPalStore.getPayPalSuccessRoute);
    }
  } catch (err) {
    logException(err as Error, componentName);
  }
});

onUnmounted(() => {
  logEvent("unmounted", componentName);
});
</script>
